import React from 'react';

import EventDefault from './event-default';
import ConvSource from '../conv-source';

const EventInitConv = props => {
  const { data } = props;
  return (
    <>
      <EventDefault data={data} />
      <ConvSource data={data?.extra} />
    </>
  );
};

export default EventInitConv;
